import React, {useState} from "react";
import {Page} from "../../components/page/page";
import {useDispatch, useSelector} from "react-redux";
import {setName} from "../../store/stateSlice";
import {NameInput} from "../../../../components/name-input/name-input";

const YourNamePage = () => {
    const state = useSelector(store => store.predictions);
    const [isInputValid, setInputValidity] = useState(!!state.name);
    const [value, setValue] = useState(null)
    const dispatch = useDispatch();

    const inputNameStyles = {
        borderColor: '#ffffff'
    }

    return (
        <Page
            title="What is your name?"
            nextPageLink="../your-birthdate"
            onContinue={() => dispatch(setName(value))}
            canGoToNextPage={isInputValid}
        >
            <NameInput defaultVal={state.name && state.name}
                       setValid={setInputValidity}
                       setValue={setValue}
                       inputNameStyles={inputNameStyles}
            />
        </Page>
    );
};

export {YourNamePage};
